import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import {
	Box,
	Button,
	Flex,
	IconButton,
	Image,
	Text,
	useColorMode,
} from '@chakra-ui/react';
import { userService } from 'api/services/userService';
import logoLightMode from 'assets/icon/bumbei_logo_RGB-02.png';
import logoDarkMode from 'assets/icon/bumbei_logo_RGB-04.png';
import { onboardingScreens } from 'components/onboarding/variable/carouselData';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSwipeable } from 'react-swipeable';
import { authActions } from 'store/auth';

export default function OnboardingCarrusel() {
	const [step, setStep] = useState(0);
	const current = onboardingScreens[step];
	const { colorMode } = useColorMode();
	const dispatch = useDispatch();
	const TOKEN = useSelector((state) => state.auth.tokenId);

	const nextStep = () => {
		if (step < onboardingScreens.length - 1) {
			setStep(step + 1);
		}
	};

	const prevStep = () => {
		if (step > 0) {
			setStep(step - 1);
		}
	};

	const handlers = useSwipeable({
		onSwipedLeft: () => nextStep(),
		onSwipedRight: () => prevStep(),
		preventDefaultTouchmoveEvent: true,
		trackTouch: true,
	});

	const handleFinish = async () => {
		dispatch(authActions.setIsNewUser(true));
		await userService.updateMetadata(TOKEN, { isBoarded: true });
	};
	return (
		<Flex
			direction='column'
			align='center'
			justify='flex-start'
			p={6}
			h='100vh'
			bg='brand.gray'
			position='relative'
			overflow='hidden'
			{...handlers}
		>
			<Box mb={6}>
				<Image
					src={colorMode === 'light' ? logoLightMode : logoDarkMode}
					alt='Bumbei Logo'
					boxSize='280px'
					objectFit='contain'
				/>
			</Box>
			<Box
				position='relative'
				width='100%'
				maxWidth='400px'
				height='320px'
				mb={8}
			>
				<AnimatePresence mode='wait'>
					<motion.div
						key={step}
						initial={{ opacity: 0, x: 100 }}
						animate={{ opacity: 1, x: 0 }}
						exit={{ opacity: 0, x: -100 }}
						transition={{ duration: 0.4 }}
						style={{
							position: 'absolute',
							width: '100%',
							top: 0,
							left: 0,
							zIndex: 1,
						}}
					>
						<Text fontSize='3xl' fontWeight='bold' mb={4} textAlign='center'>
							{current.emoji} {current.title}
						</Text>
						<Text fontSize='md' textAlign='center' whiteSpace='pre-wrap' mb={4}>
							{current.body}
						</Text>
						<Text fontSize='sm' textAlign='center' mb={8}>
							{current.subtext}
						</Text>
						{current.cta ? (
							<Button
								onClick={handleFinish}
								variant='brand'
								size='lg'
								fontWeight='bold'
								width='100%'
							>
								{current.cta}
							</Button>
						) : (
							<Button onClick={nextStep} variant='brand' size='lg' width='100%'>
								Siguiente
							</Button>
						)}
						<Box mt={6} position='relative' width='100%' textAlign='center'>
							{/* Step Counter */}
							<Text fontSize='xs'>
								{step + 1} / {onboardingScreens.length}
							</Text>

							{/* Left Arrow */}
							{step > 0 && (
								<IconButton
									aria-label='Anterior'
									icon={<ChevronLeftIcon />}
									size='xs'
									variant='ghost'
									position='absolute'
									left='0'
									top='50%'
									transform='translateY(-50%)'
									onClick={prevStep}
								/>
							)}

							{/* Right Arrow */}
							{step < onboardingScreens.length - 1 && (
								<IconButton
									aria-label='Siguiente'
									icon={<ChevronRightIcon />}
									size='xs'
									variant='ghost'
									position='absolute'
									right='0'
									top='50%'
									transform='translateY(-50%)'
									onClick={nextStep}
								/>
							)}
						</Box>

						<Flex justifyContent='center'>
							<Button mt={4} size='sm' variant='ghost' onClick={handleFinish}>
								Saltar
							</Button>
						</Flex>
					</motion.div>
				</AnimatePresence>
			</Box>
		</Flex>
	);
}
